import moment from 'moment';
import {
  SOCKET_CONNECTION_UNKNOWN,
  SOCKET_CONNECTION_CONNECT,
  SOCKET_CONNECTION_DISCONNECT,
  SOCKET_CONNECTION_RECONNECT,
} from '../constants/ActionTypes';

export default function connection(
  state = { status: SOCKET_CONNECTION_UNKNOWN, reason: '', timestamp: '' },
  action
) {
  switch (action.type) {
    case SOCKET_CONNECTION_UNKNOWN:
      return {
        status: SOCKET_CONNECTION_UNKNOWN,
        reason: '',
        timestamp: '',
      };
    case SOCKET_CONNECTION_CONNECT:
      return {
        status: SOCKET_CONNECTION_CONNECT,
        reason: '',
        timestamp: '',
      };
    case SOCKET_CONNECTION_DISCONNECT:
      return {
        status: SOCKET_CONNECTION_DISCONNECT,
        reason: action.data,
        timestamp: moment.utc().valueOf(),
      };
    case SOCKET_CONNECTION_RECONNECT:
      return {
        status: SOCKET_CONNECTION_RECONNECT,
        reason: '',
        timestamp: moment.utc().valueOf(),
      };
    default:
      return {
        ...state,
      };
  }
}
